angular.module("mobilezuz").config(["$stateProvider", config]);

var ctrlName = "coMapCtrl";

function config($stateProvider) {
  // KEEP STATE NAME SAME LEVEL WITH CHECKOUT PROCESS
  // app.cart.checkout.process.address.map will lead to bug can't redirect

  $stateProvider.state("app.cart.checkout.process.map", {
    url: "/map?from",

    checkoutViewOriginalIndex: 1.5,
    // same with address to show same step in UI
    checkoutViewIndex: 1.5,
    views: {
      checkoutProcess: {
        templateUrl: "views/checkout/process/map.html",
        // reuse googleMapDialogCtrl name because reuse template
        controller: "CheckoutMapCtrl as " + ctrlName,
      },
    },
  });
}

/**
 * @typedef {Object} AddressDetails
 * @property {number} lat
 * @property {number} lng
 * @property {string} city
 * @property {string} text1
 * @property {string} country
 * @property {string} placeId
 */

angular
  .module("mobilezuz")
  .controller("CheckoutMapCtrl", [
    "GMap",
    "LocationService",
    "$timeout",
    "$state",
    "$stateParams",
    "$scope",
    "$rootScope",
    "Util",
    "Config",
    "AddressService",
    controller,
  ]);

function controller(
  GMap,
  LocationService,
  $timeout,
  $state,
  $stateParams,
  $scope,
  $rootScope,
  Util,
  Config,
  AddressService
) {
  var ctrl = this;
  var checkoutProcessCtrl = $scope.checkoutProcessCtrl;

  angular.extend(ctrl, {
    isHideSaveBtn: true,
    isShowAutoComplete: false,
    markerPopup: null,
    addressDetails: {
      lat: 0,
      lng: 0,
      city: "",
      text1: "",
      country: "",
      placeId: "",
      hasHouseNumberAndRoute: true
    },
    formattedAddress: "",

    infoWindow: null,
    searchValue: "",
    map: null,
    mapErrorMessage: "",

    handleCloseDialog: nextView,
    getAutoCompleteAddressOptions: getAutoCompleteAddressOptions,
    onChooseSearchOption: onChooseSearchOption,
  });

  angular.extend(checkoutProcessCtrl, {
    nextView: nextView,
    previousView: previousView,
  });

  //================== FUNCTIONS  ==================//

  _init();

  function _init() {
    // map is render BELOW webview, so should hide/transparent all UI
    // https://github.com/mapsplugin/cordova-plugin-googlemaps?tab=readme-ov-file#how-does-this-plugin-work-android-ios
    $rootScope.$emit("cart.hideCartPage");

    LocationService.getUserDefaultLocation()
      .then(function (latLng) {
        initGoogleMapMobile(latLng);
      })
      .catch(function (error) {
        ctrl.mapErrorMessage = error.message;
      });
  }

  /**
   *
   * @param {MGeocode} geocode
   */
  function setAddress(geocode) {
    // need $timeout so adrs can be shown on UI
    $timeout(function () {
      ctrl.formattedAddress = geocode.extra.lines[0];
      var text1Obj = Util.constructAdrsText1(geocode.countryCode, geocode.subThoroughfare, geocode.thoroughfare, geocode.locality);
      angular.extend(ctrl.addressDetails, {
        lat: geocode.position.lat,
        lng: geocode.position.lng,
        city: geocode.locality || geocode.adminArea,
        text1: text1Obj.value,
        country: geocode.country,
        countryCode: geocode.countryCode,
        placeId: "",
        hasHouseNumberAndRoute: text1Obj.hasHouseNumberAndRoute
      });
    }, 0);
  }

  /**
   *
   * @param {MGeocodePosition} latLng
   */
  function initDefaultAddress(latLng) {
    GMap.reverseGeocode(latLng)
      .then(function (geocode) {
        setAddress(geocode);
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  /**
   * @param {*} map
   * @param {MGeocodePosition} latLng
   */
  function initMarker(map, latLng, infoWindow) {
    var marker = GMap.initMarker(map, latLng);
    GMap.moveMapMoveMarkerListener(map, marker, setAddress);

    GMap.clickMarkerTogglePopupListener({
      marker: marker,
      infoWindow: infoWindow,
    });
  }

  /**
   *
   * @param {*} map
   * @param {MGeocodePosition} latLng
   */
  function onMapReady(map, latLng) {
    ctrl.map = map;
    ctrl.infoWindow = GMap.initInfoWindow();

    initMarker(map, latLng, ctrl.infoWindow);
    // MUST init default after init marker -> marker can show address
    initDefaultAddress(latLng);
  }

  /**
   *
   * @param {MGeocodePosition} latLng
   */
  function initGoogleMapMobile(latLng) {
    var mapRef = document.getElementById("map");
    var options = {
      camera: {
        target: latLng,
        zoom: 17,
      },
    };

    GMap.initMap(mapRef, options)
      .then(function (map) {
        onMapReady(map, latLng);
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  /**
   * @param {Geocode[]} geocodes
   * @returns {{city: string, text1: string, hasHouseNumberAndRoute: boolean}}
   */
  function reverseFullAddressFromGeocodes(geocodes) {
    var geo = geocodes.results && geocodes.results[0];

    if (!geo) {
      return null;
    }

    var extractedInfo = GMap.extractInfoFromAddrComponents(geo.address_components);
    var text1Obj = Util.constructAdrsText1(extractedInfo.countryCode, extractedInfo.houseNumber, extractedInfo.route, extractedInfo.city)

    return {
      city: extractedInfo.city,
      text1: text1Obj.value,
      hasHouseNumberAndRoute: text1Obj.hasHouseNumberAndRoute
    };
  }

  function returnToAddressScreen() {
    $state.go($stateParams.from, { addressDetails: JSON.stringify(ctrl.addressDetails) });
  }

  // ECOM-5552 [AutoComplete] - Chosen address from google map is written backwards. not work well on native ios app.
  function handleIosReverseText() {
    if (
      !window.cordova ||
      window.cordova.platformId !== "ios" ||
      ctrl.addressDetails.countryCode !== "IL"
    ) {
      return Promise.resolve();
    }

    return AddressService.geocodeByGgMapApi({
      lat: ctrl.addressDetails.lat,
      lng: ctrl.addressDetails.lng,
      languageId: Config.language.id,
    }).then(function (geocodes) {
      var newAdrsDetails = reverseFullAddressFromGeocodes(geocodes);

      if (newAdrsDetails) {
        ctrl.addressDetails.text1 = newAdrsDetails.text1;
        ctrl.addressDetails.city = newAdrsDetails.city;
        ctrl.addressDetails.hasHouseNumberAndRoute = newAdrsDetails.hasHouseNumberAndRoute;
      }
    });
  }

  /**
   *
   * @param {AddressDetails} addressDetails
   */
  function nextView() {
    if (!ctrl.addressDetails) {
      return;
    }

    handleIosReverseText().then(function () {
      returnToAddressScreen();
    });
  }

  function previousView() {
    return checkoutProcessCtrl.goToState("app.cart.checkout.process.address");
  }

  function getAutoCompleteAddressOptions() {
    if (!ctrl.searchValue) {
      return Promise.resolve([]);
    }

    return GMap.geocoding(ctrl.searchValue, Config.language.id)
      .then(function (geocodes) {
        return geocodes;
      })
      .catch(function () {
        return [];
      });
  }

  function onChooseSearchOption($event) {
    var selectedGeocode = $event && $event.option;

    if (!selectedGeocode) {
      return;
    }

    if (ctrl.map) {
      GMap.moveCamera(ctrl.map, selectedGeocode.position);
    }

    // delay setAddress so moveMapMoveMarkerListener callback run ealier -> set address with selectedGeocode and not reverseGeocode again
    $timeout(function () {
      // ECOM-6533. Must delay to override sp-autocomplete focus input
      document.activeElement.blur();
      setAddress(selectedGeocode);
    }, 200);
  }

  //================== SCOPE LISTENER  ==================//

  $scope.$watch(ctrlName + ".formattedAddress", function () {
    GMap.setContentInfoWindow(ctrl.infoWindow, GMap.formatPopupContent(ctrl.formattedAddress));
  });
}
